// @flow

import React, { Component } from 'react'

import './CommentsAndReactionsBlock.css'

type Props = {
  commentsEnabled: boolean,
  likesEnabled: boolean,
  totalComments: number,
  totalLikes: number,
  totalReactions: number,
  accountDetails: object,
  title: string,
  loading: boolean
}

/**
  * Diplay for medium info block
  * @class
  * @extends Component
*/
class CommentsAndReactionsBlock extends Component<Props> {
  /** render function */
  render () {
    const getBody = () => {
      if (this.props.loading) return null
      if (!this.props.likesEnabled && !this.props.commentsEnabled) {
        return (
          <div style={{ color: '#A3AEBD', position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)', width: 'fit-content' }}>
            {this.props.accountDetails && this.props.accountDetails.ui_version === 'v1' ? 'Reactions' : 'Likes' } and comments not enabled for this post
          </div>
        )
      }

      return (
        <div className='flex align-end space-between'>
          {getComments()}
          {getLikes()}
          {getReactions()}
        </div>
      )
    }

    const getComments = () => {
      if (!this.props.commentsEnabled) {
        return <div className='flex' style={{ marginTop: 'auto', color: '#A3AEBD' }}>Comments not enabled for this post</div>
      }
      return <div className='flex'>
        <h1>{this.props.totalComments}</h1>
        <div style={{ marginTop: 'auto' }}>{this.props.totalComments === 1 ? 'COMMENT' : 'COMMENTS'}</div>
      </div>
    }
    const getLikes = () => {
      if (this.props.accountDetails && this.props.accountDetails.ui_version === 'v1') {
        return null
      }
      if (!this.props.likesEnabled) {
        return (<div className='flex' style={{ marginTop: 'auto', color: '#A3AEBD' }}>Likes not enabled for this post</div>)
      }
      return <div className='flex'>
        <h1>{this.props.totalLikes}</h1>
        <div style={{ marginTop: 'auto', paddingLeft: '8px' }}>{this.props.totalLikes === 1 ? 'LIKE' : 'LIKES'}</div>
      </div>
    }
    const getReactions = () => {
      if (this.props.accountDetails && this.props.accountDetails.ui_version === 'v1') {
        if (!this.props.likesEnabled) {
          return (<div className='flex' style={{ marginTop: 'auto', color: '#A3AEBD' }}>Reactions not enabled for this post</div>)
        }
        return <div className='flex'>
          <h1>{this.props.totalReactions}</h1>
          <div style={{ marginTop: 'auto', paddingLeft: '8px' }}>{this.props.totalReactions === 1 ? 'REACTION' : 'REACTIONS'}</div>
        </div>
      }
      return null
    }
    const body = getBody()
    return (
      <div className='CommentsAndReactionsBlock'>
        <h5> {this.props.title}</h5>
        {body}
      </div>
    )
  }
}

export default CommentsAndReactionsBlock
